import { render, staticRenderFns } from "./TicketContent.vue?vue&type=template&id=57f99232&"
import script from "./TicketContent.vue?vue&type=script&lang=ts&"
export * from "./TicketContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports